@if (valueType === 'currency') {
  <div class="am-flex-align gap-xs">
    <span class="am-flex-align am-flex-justify-end gap-xs height-40 width-100 p-xxs" [ngClass]="editBox === index ? 'b-grey' : 'b-white'">
      @if (editBox === index) {
        <input class="transparent font-l p-0 text-right editable-input-field" maxlength="255" type="text" inputmode="numeric" pattern="[0-9]*"
              [id]="'edit-field-' + index"
              [value]="value"
              (input)="onInput($event)"
              (keydown)="onKeyDown($event)"
              (blur)="onBlur($event)"
              [disabled]="editBox !== index">
      } @else { <span class="roboto">{{ formatByTypeForPreview(value) }}</span> }
      @if (postValue) { <span>{{ postValue }}</span> }
    </span>
    <span (click)="toggleEditableInput(index)" [ngClass]="showEdit ? '' : 'hide events-none'" class="am-flex-center color-blue hover-active icon-edit width-20 text-m " [class.hide-pencil]="editBox === index"></span>
  </div>
} @else {
  @if (editBox === index) {
    <input class="transparent editable-input-field" maxlength="255" type="text"
          [id]="'edit-field-' + index"
          [value]="value"
          (input)="onInput($event)"
          (blur)="onBlur($event)"
          (keydown)="onKeyDown($event)"
          [disabled]="editBox !== index">
  }
  @if (editBox !== index) { <span>{{formatByTypeForPreview(value)}}</span> }
  @if (postValue        ) { <span class="pl-xxs">{{postValue}}</span> }
  @if (showEdit         ) { <span (click)="toggleEditableInput(index)" class="am-flex-center color-blue hover-active icon-edit width-20 text-m" [class.hide-pencil]="editBox === index"></span> }
}